import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map-route-time",
  "use": "icon-map-route-time-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"icon-map-route-time\">\n<path d=\"M12,4c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S16.4,4,12,4z M14.4,13.2c-0.1,0.2-0.3,0.3-0.4,0.3c-0.1,0-0.2,0-0.2-0.1l-2-1\n\tc-0.2-0.1-0.3-0.3-0.3-0.4V8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v3.7l1.7,0.9C14.5,12.7,14.6,13,14.4,13.2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol